import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=26073e52&scoped=true&"
import script from "./brandList.vue?vue&type=script&lang=js&"
export * from "./brandList.vue?vue&type=script&lang=js&"
import style0 from "./brandList.vue?vue&type=style&index=0&id=26073e52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26073e52",
  null
  
)

export default component.exports